export default {
  SET_CARD_INFO(state, data) {
    state.cardInfo = data;
  },
  SET_BANK_CARD_INFO(state, data) {
    state.bankCardInfo = data;
  },
  SET_MONEY_NUM(state, data) {
    state.moneyNum = data;
    sessionStorage.setItem('AMOUNT_OF_CHARGE', data);
  },
  REMOVE_MONEY_NUM(state) {
    state.moneyNum = 0;
    sessionStorage.removeItem('AMOUNT_OF_CHARGE');
  },
  SET_DELETE_CARD_STATUS(state, data) {
    state.deleteCardStatus = data;
  },
  SET_CHARGE_OPTION(state, data) {
    state.chargeOptions = data;
    sessionStorage.setItem('CHARGE_OPTIONS', JSON.stringify(data));
  },
  REMOVE_CHARGE_OPTIONS(state) {
    state.chargeOptions = {
      chargeType: '',
      conbiniCode: '',
    };
    sessionStorage.removeItem('CHARGE_OPTIONS');
  },
  SET_BANK_LIST(state, data) {
    state.bankList = data;
  },
};
